import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{ background: 'none' }}
      copyright="株式会社三栄"
      links={[
        {
          key: 'line',
          href: 'https://line.me/R/ti/p/@709yhpej', // ✅ これ追加
          title: (
            <>
              お問い合わせの場合は
              <a
                href="https://line.me/R/ti/p/@709yhpej"
                target="_blank"
                rel="noopener noreferrer"
              >
                LINE
              </a>
              へ内容を送信してください。
            </>
          ),
        },
      ]}
    />
  );
};

export default Footer;
